exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".spectrum--darkest  {\n  background-color: rgb(30, 30, 30);\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n", "", {"version":3,"sources":["/jenkins/workspace/CCX-Comments-Release/node_modules/@react/react-spectrum/spectrum-css/page/multiStops/darkest.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,2CAA2C;CAC5C","file":"darkest.css","sourcesContent":[".spectrum--darkest  {\n  background-color: rgb(30, 30, 30);\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n"],"sourceRoot":""}]);

// exports
